// import

import clsx from 'clsx';
import {styled} from 'goober';
import type {ComponentProps, ReactNode} from 'react';

// types

type Props = ComponentProps<typeof Block> & {
  content?: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  sidebar?: ReactNode;
  showSidebar?: boolean;
  stickySidebar?: boolean;
  sidebarMax?: string;
};

// component

export function ContentSidebar(props: Props) {
  const {content, sidebar, header, footer, showSidebar = true, stickySidebar = true, sidebarMax = '17rem', ...rest} = props;
  const withSidebar = sidebar && showSidebar;

  return (
    <Block {...rest} style={{'--sidebar-max': sidebarMax}}>
      {header}

      <div className="asc-inner">
        <article className="asc-content" data-test="content-main">
          {content}
        </article>

        {withSidebar ? (
          <aside
            className={clsx('asc-sidebar', {
              sticky: stickySidebar,
            })}
            data-test="content-side"
          >
            {sidebar}
          </aside>
        ) : null}
      </div>

      {footer}
    </Block>
  );
}

// styles

const Block = styled('section')`
  padding: 6rem 1.5rem;
  position: relative;

  .asc-inner {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: center;
    gap: 4.5rem;
  }

  .asc-content {
    flex: 1 1 auto;
    max-width: var(--bp-sm);
  }

  .asc-sidebar {
    flex: 1 0 16rem;
    min-width: 16rem;
    max-width: var(--sidebar-max);

    &.sticky {
      position: sticky;
      top: calc(var(--layout-header-height) + 1.5rem);
    }
  }

  @media (max-width: 53.99875em) {
    .asc-content {
      margin-left: auto;
      margin-right: auto;
    }

    .asc-sidebar {
      display: none;
      visibility: hidden;
    }
  }
`;
